import React from 'react'
//import background2 from'../assets/background2.png';
import'../css/teamCard.css';
export default function TeamCard({img,title,name}) {
  return (
    <div class="card text-center bg-transparent border-color-transparent "   data-aos="zoom-in-up"  data-aos-easing="ease-out-cubic"
    data-aos-duration="1500">
    <img src={img} class="card-img bg-light rounded " alt="test image" />
    <div class=" card-body bg-dark mx-3 rounded-3 ">
      <h6 class="card-title text-primary "> {title} </h6>
      <p class="card-text  fs-4  text-white "> {name} </p>     
    </div>
  </div>  
  )
}
